export function chartAxisTicks(rows) {
  if (rows.length <= 20) return rows.map(row => row.x);
  // Bound Recharts' synchronous text measurements without dropping chart data.
  return Array.from({ length: 20 }, (_, index) =>
    rows[Math.round(index * (rows.length - 1) / 19)].x
  );
}
